/** Small, minimalist peyote-inspired brand mark used beside the "peyotl.mx" wordmark. */
export function PeyotlMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path
        d="M24 16c-7-7-15-2-15 6 0 5 3 8 7 9-1 5 2 9 8 9s9-4 8-9c4-1 7-4 7-9 0-8-8-13-15-6Z"
        fill="currentColor"
        opacity=".92"
      />
      <path
        d="M24 18v20M14 25c4 0 7 2 9 5M34 25c-4 0-7 2-9 5"
        fill="none"
        stroke="#faf7f0"
        strokeLinecap="round"
        strokeWidth="1.6"
      />
      <path
        d="M24 15c-2-5 1-10 4-11 2 4 1 8-4 11ZM23 15c-4-5-8-5-10-3 2 4 6 5 10 3ZM26 15c4-5 8-5 10-3-2 4-6 5-10 3Z"
        fill="#faf3df"
        stroke="currentColor"
        strokeWidth=".7"
      />
    </svg>
  );
}

const iconCommon = {
  fill: "none" as const,
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  strokeWidth: 1.7,
};

/** Line icons for the six focus areas: lightbulb, flask, people, leaf, code, globe. */
export function FocusIcon({ index }: { index: number }) {
  return (
    <svg className="focus-icon-art" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      {index === 0 && (
        <>
          <path {...iconCommon} d="M16 21a8 8 0 1 1 16 0c0 3-1 5-3 7-1 1-2 2-2 4h-6c0-2-1-3-2-4-2-2-3-4-3-7Z" />
          <path {...iconCommon} d="M21 37h6M22 41h4" />
        </>
      )}
      {index === 1 && (
        <>
          <path {...iconCommon} d="M20 9h8M22 9v9l-8 19h20l-8-19V9" />
          <path {...iconCommon} d="M17 32h14M19 27h10" />
        </>
      )}
      {index === 2 && (
        <>
          <circle {...iconCommon} cx="24" cy="14" r="5" />
          <circle {...iconCommon} cx="12" cy="22" r="4" />
          <circle {...iconCommon} cx="36" cy="22" r="4" />
          <path {...iconCommon} d="M14 37v-5c0-5 4-8 10-8s10 3 10 8v5M5 37v-3c0-3 2-5 6-6M43 37v-3c0-3-2-5-6-6" />
        </>
      )}
      {index === 3 && (
        <>
          <path {...iconCommon} d="M34 10C20 12 13 19 14 31c9 1 17-5 20-21Z" />
          <path {...iconCommon} d="M12 39 30 19M20 31l-5-1M25 25l-1-5" />
        </>
      )}
      {index === 4 && <path {...iconCommon} d="m18 15-9 9 9 9M30 15l9 9-9 9M27 12l-6 24" />}
      {index === 5 && (
        <>
          <circle {...iconCommon} cx="24" cy="24" r="15" />
          <path
            {...iconCommon}
            d="M9 24h30M24 9c5 5 7 10 7 15s-2 10-7 15M24 9c-5 5-7 10-7 15s2 10 7 15M12 15h24M12 33h24"
          />
        </>
      )}
    </svg>
  );
}
